export const COACH_PENDING_KINDS = {
  REPLAN_DRAFT: "REPLAN_DRAFT",
  PENDING_RECOMMENDATION: "PENDING_RECOMMENDATION",
  SAFE_RECOVERY_AUTO: "SAFE_RECOVERY_AUTO",
};

export const normalizeCoachPendingAction = (raw) => {
  if (raw == null || typeof raw !== "object" || Array.isArray(raw)) {
    return { pendingCount: 0, primary: null };
  }
  const pendingCount = typeof raw.pending_count === "number"
    ? Math.max(0, raw.pending_count)
    : 0;
  const primaryRaw = raw.primary;
  if (!primaryRaw || typeof primaryRaw !== "object" || Array.isArray(primaryRaw)) {
    return { pendingCount, primary: null };
  }
  const kind = typeof primaryRaw.kind === "string" ? primaryRaw.kind.trim() : "";
  const headline = typeof primaryRaw.headline === "string"
    ? primaryRaw.headline.trim()
    : "";
  const message = typeof primaryRaw.message === "string"
    ? primaryRaw.message.trim()
    : "";
  const actionLabel = typeof primaryRaw.action_label === "string"
    ? primaryRaw.action_label.trim()
    : "";
  const targetPath = typeof primaryRaw.target_path === "string"
    ? primaryRaw.target_path.trim()
    : "/coach";
  const targetHash = typeof primaryRaw.target_hash === "string"
    ? primaryRaw.target_hash.trim()
    : null;
  if (!kind || !headline || !actionLabel) {
    return { pendingCount, primary: null };
  }
  const href = targetHash ? `${targetPath}#${targetHash}` : targetPath;
  return {
    pendingCount,
    primary: {
      kind,
      headline,
      message,
      actionLabel,
      targetPath,
      targetHash,
      href,
    },
  };
};

export const buildCoachPendingHref = (primary) => primary?.href || "/coach";
